export default __webpack_public_path__ + "img/office.7a4b0550.png";